import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTranslation } from "react-i18next";

const TeamDataColumnChart = (props) => {

  const [translation] = useTranslation("translations");

    const options = {
        chart: {
          backgroundColor: null,
          borderWidth: 0,
          type: 'spline',
          height: 160,
          style: {
            overflow: 'visible'
          },
          margin: [2, 0, 2, 0],
      
          // small optimalization, saves 1-2 ms each sparkline
          skipClone: true
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: {
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          // startOnTick: false,
          // endOnTick: false,
          // tickPositions: [],
          categories: props.dates
        },
        // yAxis: {
        //   endOnTick: false,
        //   startOnTick: false,
        //   labels: {
        //     enabled: false
        //   },
        //   title: {
        //     text: null
        //   },
        //   tickPositions: [0]
        // },
        yAxis: {
          type: 'linear',
          min: 12,
          max: 72,
          categories: [0, 12, 20, 40, 60, 72],
          title: {
            text: null
          },
          plotBands: [{ // Light air
              from: 0,
              to: 12,
              color: 'rgba(255,255,255,1)',
              label: {
                  text: '',
                  style: {
                      color: '#fff'
                  }
              }
          },
              { // Light air
              from: 12,
              to: 24,
              color: 'rgba(178, 55, 34, 0.8)',
              label: {
                  text: '',
                  style: {
                      color: '#fff'
                  }
              }
          }, { // Light breeze
              from: 24,
              to: 59,
              color: 'rgba(233, 185, 15, 0.8)',
              label: {
                  text: '',
                  style: {
                      color: '#f1c232'
                  }
              }
          }, { // Gentle breeze
              from: 59,
              to: 72,
              color: 'rgba(119, 132, 65, 0.8)',
              label: {
                  text: '',
                  style: {
                      color: '#6aa750'
                  }
              }
          }]
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<b>{series.name}</b><br />',
          formatter: function () {
              let returnFormat = `${translation('date')} = ${this.x}<br />HWI = ${this.y}`;

              return returnFormat;
          },
      },
        exporting: {
            enabled:false
        },
        plotOptions: {
          spline: {
              lineWidth: 3,
              states: {
                  hover: {
                      lineWidth: 4
                  }
              },
              marker: {
                  enabled: true
              }
          },
          series: {
              connectNulls: true
          }
          
      },
        // plotOptions: {
        //   series: {
        //     animation: false,
        //     lineWidth: 1,
        //     shadow: false,
        //     states: {
        //       hover: {
        //         enabled: false
        //       }
        //     },
        //     marker: {
        //       radius: 1,
        //       states: {
        //         hover: {
        //           radius: 2
        //         }
        //       }
        //     },
        //     fillOpacity: 0.25
        //   },
        //   column: {
        //     negativeColor: '#910000',
        //     borderColor: 'silver'
        //   }
        // },
        series: [{
          data: props?.data,
          color: "#486975",
        }]
    };

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )

}

export default TeamDataColumnChart;